/**
 * Renvoie une Promise qui resolve au bout d'un temps donné
 */
const sleep = (delayMs: number) =>
    new Promise(resolve => setTimeout(resolve, delayMs));

export default sleep;
